import { forwardRef } from 'react';
export const fixedForwardRef = (render) => forwardRef(render);
